import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout";
import axios from "../../../config/axiosConfig";
import { CircularProgress, Typography, Box } from "@mui/material";
import FormularioOT from "../components/FormularioOT";

const CrearOrdenPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const codCliente = params.get("cliente");

  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!codCliente) {
      navigate("/orden-de-trabajo");
      return;
    }

    axios.get(`/api/cliente-servicio/${codCliente}`)
      .then((res) => {
        if (res.data.estado !== "Activo") {
          navigate("/orden-de-trabajo");
        } else {
          setCliente(res.data);
        }
      })
      .catch(() => {
        navigate("/orden-de-trabajo");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [codCliente, navigate]);

  return (
    <DashboardLayout>
      <Box sx={{ p: 4 }}>
        {loading ? (
          <CircularProgress />
        ) : cliente ? (
          <>
            <Typography variant="h5" gutterBottom>
              Crear Orden de Trabajo
            </Typography>
            <Typography variant="subtitle1" sx={{ mb: 3 }}>
              Cliente: <strong>{cliente.nombre_cliente}</strong> (Código: {cliente.cod_servicio_cliente})
            </Typography>
            <FormularioOT cliente={cliente} />
          </>
        ) : (
          <Typography color="error">Cliente no válido o inactivo.</Typography>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default CrearOrdenPage;